import { Link } from "react-router-dom";
import type { Episode } from "@/mocks/episodes";

interface EpisodeCardProps {
  episode: Episode;
}

export default function EpisodeCard({ episode }: EpisodeCardProps) {
  return (
    <Link
      to={`/detail/episode/${episode.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={episode.cover}
          alt={`第${episode.ep}集 ${episode.title}`}
          title={`年轻的母亲1 第${episode.ep}集 ${episode.title}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-950/80 px-2 py-1 text-xs font-semibold text-background-50">
          第 {episode.ep} 集
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-accent-500/95 px-2 py-1 text-[11px] font-medium text-background-50">
          {episode.status}
        </span>
        <span className="absolute bottom-2 right-2 rounded-md bg-primary-950/75 px-2 py-0.5 text-[11px] text-background-100">
          <i className="ri-time-line mr-1" />
          {episode.duration}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-1 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {episode.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{episode.summary}</p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span>
            <i className="ri-calendar-line mr-1" />
            {episode.airDate}
          </span>
          <span>
            <i className="ri-fire-line mr-1 text-accent-500" />
            {episode.views}
          </span>
        </div>
      </div>
    </Link>
  );
}